import { HttpClient } from '@angular/common/http';
import { environment } from './../../../../environments/environment';
import { Injectable } from '@angular/core';



@Injectable({
  providedIn: 'root'
})
export class SearchPropertyBoardService {

  constructor(
    private http : HttpClient
  ) { }

  getListLocation(data) {
    return this.http.post(
      environment.authenticationUrl +'property/property/ist/search',data
    );
  }
  getListLocationNew(data) {
    return this.http.post(
      environment.authenticationUrl +'property/property/ist/search/locality',data
    );
  }
}
